export const itemList = [
    {
        id: 1,
        name: "Beef Burger",
        img: "beefBurger.jpg",
        price: '3.5',
        daily: 45,
        weekly: 70
    },
    {
        id: 2,
        name: "Beef Sandwich Burger",
        img: "beefSandwichBurger.png",
        price: '5.5',
        daily: 23,
        weekly: 60
    },
    {
        id: 4,
        name: "Burger + Fries",
        img: "burgerPlusFries.jpg",
        price: '3',
        daily: 45,
        weekly: 80
    },
    {
        id: 5,
        name: "Double Cheese Burger",
        img: "doubleCheeseburger.jpg",
        price: '3.5',
        daily: 54,
        weekly: 60
    },
    {
        id: 8,
        name: "One Set",
        img: "oneBurgerSet.jpg",
        price: '4',
        daily: 22,
        weekly: 84
    },
    
    {
        id: 10,
        name: "Jet Black Burger",
        img: "jetblackburger.jpg",
        price: '3.5',
        daily: 60,
        weekly: 120
    },  
    {
        id: 3,
        name: "Burger Charming",
        img: "burgerCharming.jpg",
        price: '2.5',
        daily: 34,
        weekly: 56
    },
    {
        id: 6,
        name: "Fresh Burger",
        img: "freshBurger.jpg",
        price: '3',
        daily: 65,
        weekly: 80
    },
    {
        id: 9,
        name: "Spicy Burger",
        img: "spicyBurger.jpg",
        price: '4',
        daily: 43,
        weekly: 70
    },
    {
        id: 11,
        name: "Triple Beef Burger",
        img: "tripleBeefBurger.jpg",
        price: '5.5',
        daily: 54,
        weekly: 89
    },
    {
        id: 12,
        name: "Beef Hotdog",
        img: "beefSandwich.jpg",
        price: '4.5',
        daily: 54,
        weekly: 60
    }, 
    {
        id: 7,
        name: "Fries",
        img: "fries.jpg",
        price: '1.5',
        daily: 72,
        weekly: 150
    }
];